import { type Company } from 'src/shared/types/company';
import { useGetCompaniesPaginateAllQuery } from 'src/shared/api/company';
import { useFormState } from 'react-final-form';

const useStep2 = () => {
  const { values } = useFormState();
  const { data: companies } = useGetCompaniesPaginateAllQuery({ searchValue: '' });

  const companiesToSelect = companies;

  return { values, companiesToSelect };
};

export default useStep2;
